module.exports = global["jQuery"] = require("-!/data/sites/web/febelautobe4002/deploy/node_modules/expose-loader/index.js?$!./jquery.js");